export const codes = {
  CURRENCY: 'Currency',
  DATE_SHORT: 'DateShort',
  DATE_LONG: 'DateLong',
}
